/**
 * Decyzon brand asset paths — SINGLE SOURCE OF TRUTH.
 *
 * All references to logo / favicon / OG asset URLs MUST import from this file.
 * Direct string usage of `/logo-mark.svg`, `/logo-wordmark.svg`, `/favicon.ico`,
 * `/apple-touch-icon.png`, `/og-image.png`, `/email-logo.png` is forbidden
 * everywhere except `index.html` (static head) and this file.
 *
 * In-app rendering MUST go through `<DecyzonLogo />` — never reference these
 * paths from a React component.
 */

const ORIGIN = "https://www.decyzon.com";
export const BRAND_ASSET_VERSION = "20260424-adaptive";

export function withBrandAssetVersion(path: string) {
  return `${path}?v=${BRAND_ASSET_VERSION}`;
}

export const BRAND_ASSETS = {
  /** Canonical mark SVG. True vector, transparent, currentColor strokes. */
  markSvg:        "/logo-mark.svg",
  /** Canonical wordmark SVG. True vector, transparent, currentColor strokes/text. */
  wordmarkSvg:    "/logo-wordmark.svg",
  /** Favicon (raster fallback for legacy clients). Transparent alpha. */
  favicon:        "/favicon.ico",
  /** Apple touch icon, 180x180, transparent alpha. */
  appleTouchIcon: "/apple-touch-icon.png",
  /** Open Graph / Twitter social card, 1200x630. Dark background — intentional for social previews. */
  ogImage:        "/og-image.png",
  /** Transparent variant of the OG card — for in-app embeds where a baked dark background would clash. */
  ogImageTransparent: "/og-image-transparent.png",
  /** Transactional email header logo, 512x512, transparent alpha. */
  emailLogo:      "/email-logo.png",
  /** JSON-LD / schema.org logo, 512x512, contrast-safe raster (white on #0B0B0B). */
  schemaLogo:     "/logo-schema.png",
} as const;

/** Absolute (origin-prefixed) variants for OG meta and JSON-LD. */
export const BRAND_ASSETS_ABSOLUTE = {
  markSvg:            `${ORIGIN}${BRAND_ASSETS.markSvg}`,
  wordmarkSvg:        `${ORIGIN}${BRAND_ASSETS.wordmarkSvg}`,
  ogImage:            `${ORIGIN}${BRAND_ASSETS.ogImage}`,
  ogImageTransparent: `${ORIGIN}${BRAND_ASSETS.ogImageTransparent}`,
  emailLogo:          `${ORIGIN}${BRAND_ASSETS.emailLogo}`,
  schemaLogo:         `${ORIGIN}${BRAND_ASSETS.schemaLogo}`,
} as const;

export type BrandAssetKey = keyof typeof BRAND_ASSETS;
